import { z } from 'zod';

import { birthDateSchema } from './BirthDate.schema';

export const petNameRequiredMsg = 'Pet name is required';
export const speciesRequiredMsg = 'Pet type is required';
export const breedRequiredMsg = 'Breed is required';
export const genderRequiredMsg = 'Gender is required';
export const weightRequiredMsg = 'Weight (lbs) is required';
export const weightNotNegativeMsg = 'Weight must be greater than 0';
export const petBaseFormSchema = z.object({
    petName: z
        .string({ message: petNameRequiredMsg })
        .trim()
        .min(1, petNameRequiredMsg)
        .max(50),
    speciesId: z.number({ message: speciesRequiredMsg }),
    isAdopted: z.boolean().optional(),
    birthDate: birthDateSchema,
    colorId: z.number().optional(),
    medications: z.string().trim().max(200).optional(),
    healthConditions: z.string().trim().max(200).optional(),
    medicalAllergies: z.string().trim().max(200).optional(),
});

export const petBaseFormSchemaVetRx = petBaseFormSchema.extend({
    breedId: z.number({
        required_error: breedRequiredMsg,
    }),
    genderId: z.number({
        required_error: genderRequiredMsg,
    }),
    weight: z
        .number({
            errorMap: () => ({ message: weightRequiredMsg }),
        })
        .refine(val => Number(val) > 0, {
            message: weightNotNegativeMsg,
        }),
});

export const bigPetFormSchema = petBaseFormSchema.extend({
    breedId: z.number({
        required_error: breedRequiredMsg,
    }),
    genderId: z.number({
        required_error: genderRequiredMsg,
    }),
    isMixedBreed: z.boolean().optional(),
    isSpayedNeutered: z.boolean().optional(),
    isPetPregnant: z.boolean().optional(),
    weight: z
        .number({
            errorMap: () => ({ message: weightRequiredMsg }),
        })
        .refine(val => Number(val) > 0, {
            message: weightNotNegativeMsg,
        }),
});
export const smallPetFormSchema = petBaseFormSchema.extend({
    genderId: z.number().optional(),
});
export const smallPetFormSchemaVetRx = petBaseFormSchema.extend({
    genderId: z.number({
        required_error: genderRequiredMsg,
    }),
});
export type MyPetFormInterface = z.infer<
    typeof petBaseFormSchema &
        Partial<typeof bigPetFormSchema> &
        Partial<typeof smallPetFormSchema>
>;

export type DrawerAddedPetInterface = Partial<
    MyPetFormInterface & { petId: number | string }
>;
